import React from "react";
import { ReactSVG } from "react-svg";
import { useModal } from "@/components/_primitives/Modal/ModalRoot/ModalRoot";
import { useAppContext } from "@/context/AppContext";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { useRating } from "@/context/RatingContext"; // Pfad anpassen
import styles from "./RecipeStars.module.scss";

export const RecipeStars = () => {
  const { user, setFormModalText } = useAppContext();
  const { getIcon, getLabel } = useGlobalContext();
  const { setOpen } = useModal();

  // Alle benötigten Daten kommen aus dem Context
  const { rating, ratingNumber, setIsVoting } = useRating();

  // --- Sterne Logik berechnen ---
  const maxRating = 5;
  let roundedRating = rating ? Math.round(rating * 2) / 2 : 0;

  // Begrenzung auf 0-5
  roundedRating = Math.max(0, Math.min(5, roundedRating));

  const isInt = Number.isInteger(roundedRating);
  if (!isInt) {
    roundedRating = roundedRating - 0.5;
  }

  const emptyStars = isInt
    ? Math.floor(maxRating - roundedRating)
    : Math.floor(maxRating - roundedRating) - 1;

  function handleClick() {
    if (!user) {
      setOpen(true);
      setFormModalText(getLabel("favorite_not_logged_in"));
    } else {
      setIsVoting(true);
    }
  }

  return (
    <>
      <button
        className={`button-reset ${styles["recipe-stars"]}`}
        onClick={handleClick}
        aria-label={getLabel("aria_label_recipe_rate_open")}
      >
        {[...Array(roundedRating)].map((star, i) => (
          <ReactSVG
            key={"Full Star " + i}
            src={getIcon("starfilled")}
            width={20}
            height={20}
            wrapper="svg"
            beforeInjection={(svg) => {
              svg.setAttribute("width", "20");
              svg.setAttribute("height", "20");
              svg.setAttribute("focusable", "false");
              svg.setAttribute("aria-hidden", "true");
            }}
          />
        ))}
        {!isInt && (
          <ReactSVG
            src={getIcon("starHalf")}
            width={20}
            height={20}
            wrapper="svg"
            beforeInjection={(svg) => {
              svg.setAttribute("width", "20");
              svg.setAttribute("height", "20");
              svg.setAttribute("aria-hidden", "true");
              svg.setAttribute("focusable", "false");
            }}
          />
        )}
        {[...Array(emptyStars)].map((star, i) => (
          <ReactSVG
            key={"Empty Star " + i}
            className="star empty-star"
            src={getIcon("starEmpty")}
            width={20}
            height={20}
            wrapper="svg"
            beforeInjection={(svg) => {
              svg.setAttribute("aria-hidden", "true");
              svg.setAttribute("width", "20");
              svg.setAttribute("height", "20");
              svg.setAttribute("focusable", "false");
            }}
          />
        ))}
        <span
          className={styles["recipe-stars-count"]}
          aria-live="polite"
          aria-label={getLabel("aria_label_number_of_rating")}
        >
          ({ratingNumber || 0})
        </span>
      </button>
    </>
  );
};

export default RecipeStars;
